import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MembershipService } from '../services/membership.service';
import { ResetPasswordModel } from 'app/models/reset-password.model';


@Injectable()
export class PasswordLinkResolver implements Resolve<ResetPasswordModel> {

    constructor(private service: MembershipService, private router: Router)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<ResetPasswordModel> {
        const reset_password_model = new ResetPasswordModel();
        reset_password_model.user_id= route.params.user_id;
        reset_password_model.reset_id= route.params.reset_id;
        return this.service.ValidatePasswordLink(reset_password_model);
    }
}
